// libs
import React, { useEffect } from "react";
import { withCookies } from "react-cookie";
// components
import ErrorNotFoundPage from "../../pages/Error/ErrorNotFoundPage";
// constants
import { useKeycloak } from "@react-keycloak/web";

const ErrorNotFoundContainer = () => {
  const { keycloak } = useKeycloak();
  useEffect(() => {
    if (!keycloak.authenticated) {
      localStorage.clear();
      keycloak.logout();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <ErrorNotFoundPage />;
};

export default withCookies(ErrorNotFoundContainer);
